module.exports = __webpack_public_path__ + "static/media/icon-5.d95e0631.png";